//Reset data
export const RESET = "SERVICE_DEL_RESET"



//Loading
export const SET_TOGGLE_LOADING = "SERVICE_DEL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "SERVICE_DEL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "SERVICE_DEL_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "SERVICE_DEL_SET_MESSAGE"
export const SET_IS_SUCCESS = "SERVICE_DEL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "SERVICE_DEL_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "SERVICE_DEL_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "SERVICE_DEL_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "SERVICE_DEL_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "SERVICE_DEL_SET_ITEMS"
export const SET_CURRENT_ITEM = "SERVICE_DEL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "SERVICE_DEL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "SERVICE_DEL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "SERVICE_DEL_SET_HIDE_MODAL"


export const SET_MODAL = "SERVICE_DEL_SET_MODAL"
export const SET_MODAL_CONTENT = "SERVICE_DEL_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "SERVICE_DEL_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "SERVICE_DEL_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "SERVICE_DEL_SET_MODAL_TYPE"
export const SET_MODAL_IS_UPDATE = "SERVICE_DEL_SET_IS_UPDATE"